/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Image from 'next/image';
import MapSvg from '../icons/map.svg';

function Centres({
  defaultSelectData, handleChangeCenter, isMobile = false, handleClose, handleMobileCurrentName, initialCentersData,
}) {
  // console.log('centres data', initialCentersData);
  const [centerSelect, setCenterSelected] = useState(defaultSelectData);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('Delhi');
  const [centerTitle, setCenterTitle] = useState('');

  const handleChange = (e) => {
    // const { value } = e;
    console.log('envt ', e);
    setCenterSelected(e.target.value);
    if (isMobile) {
      setCenterTitle(e.target.title);
    } else {
      handleChangeCenter(e.target.value);
    }
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (e) => {
    console.log('option ', e.target.title);
    const option = e.target.dataset.idValue; // Access the custom attribute
    console.log('Custom Attribute:', option);
    setSelectedOption(e.target.title);
    setCenterSelected(option);
    setIsOpen(false);
    if (isMobile) {
      handleMobileCurrentName(e.target.title);
    } else {
      handleChangeCenter(option);
    }
  };
  const handleSubmit = () => {
    handleChangeCenter(centerSelect);
    handleMobileCurrentName(centerTitle);
    handleClose();
  };

  const mobileCentrsHtml = () => (
    <div className="p-4">
      <form className="space-y-4">
        <div className="space-y-4 max-h-[266px] overflow-y-auto overflow-hidden">
          {data?.getOrganizationById?.centres.map((item) => (
            <label
              key={item.id}
              className="flex items-center space-x-2 cursor-pointer"
            >
              <input
                type="radio"
                name="centre"
                  //   checked={selectedCentre === centre}
                value={item.id}
                checked={centerSelect === item.id}
                data-ID={`${defaultSelectData} - ${item.id}`}
                title={item.name}
                onChange={handleChange}
                className="h-6 w-6 text-blue-500 focus:ring-blue-500 p-0"
              />
              <span
                className={`text-gray-700 ${
                  centerSelect === item.id
                    ? 'font-semibold'
                    : ''
                }`}
              >
                {item.name}
              </span>
            </label>
          ))}
        </div>

        <button
          type="button"
          className="bg-customBlue text-white fixed font-bold text-center w-[95%] p-4 rounded flex justify-center m-auto bottom-0 left-0 right-0 !mb-5"
          onClick={handleSubmit}
        >
          Submit
        </button>

      </form>
      {/* {selectedCentre && (
      <p className="mt-4 text-green-600">
        Selected Centre:
        {' '}
        <strong>{selectedCentre}</strong>
      </p>
      )} */}
    </div>
  );
  if (isMobile) {
    return mobileCentrsHtml();
  }
  return (
    // <div className="w-64 relative">
    //   <div className="flex items-center border border-thinBlue rounded-lg px-3 py-2 bg-white">
    //     <Image width={500} height={500} src={MapSvg} className="text-blue-500 mr-2" alt="mapicons" />
    //     <select
    //       onChange={handleChange}
    //       className="w-full bg-transparent outline-none"
    //     >
    //       {data.getOrganizationById.centres
    //         && data.getOrganizationById.centres.map((item) => (
    //           <option
    //             value={item.id}
    //             selected={defaultSelectData === item.id}
    //           >
    //             {item.name}
    //           </option>
    //         ))}
    //     </select>
    //   </div>
    // </div>
    <div className="relative w-64">
      {/* Dropdown Trigger */}
      <button
        onClick={toggleDropdown}
        className="flex items-center justify-between w-full px-4 py-[10px] bg-white border border-thinBlue rounded-lg shadow-sm"
      >
        <div className="flex items-center">
          {/* Location Icon */}
          <Image width={18} height={18} src={MapSvg} className="text-blue-500 mr-2" alt="mapicons" />
          <span className="text-gray-700 text-sm">{selectedOption}</span>
        </div>
        {/* Dropdown Arrow */}

        <svg
          width="14"
          height="7"
          viewBox="0 0 14 7"
          className={` text-customBlue transition-transform ${
            isOpen ? 'rotate-180' : ''
          }`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0.707108 1.09218C0.316607 1.41761 0.316607 1.94527 0.707107 2.27069L5.59941 6.34352C6.3805 6.99386 7.6463 6.99361 8.4271 6.34302L13.3175 2.26769C13.708 1.94227 13.708 1.41461 13.3175 1.08917C12.9269 0.763732 12.2938 0.763732 11.9032 1.08917L7.7176 4.57719C7.3271 4.90269 6.6939 4.90269 6.3034 4.57719L2.12131 1.09218C1.73081 0.76674 1.09771 0.76674 0.707108 1.09218Z" fill="#217ABB" />
        </svg>

        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-5 w-5 text-customBlue transition-transform ${
            isOpen ? 'rotate-180' : ''
          }`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4 4a.75.75 0 01-1.06 0l-4-4a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg> */}
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <ul className="absolute z-10 mt-2 w-full bg-white border border-blueThinDobule rounded-lg shadow-md max-h-60 overflow-auto border-b-[4px] border-b-[#00C3FF]">
          {initialCentersData?.getOrganizationById?.centres && initialCentersData?.getOrganizationById?.centres.map((item) => (
            <li
              title={item.name}
                //             selected={defaultSelectData === item.id}
              key={item.id}
              onClick={handleOptionClick}
              data-id-value={item.id}
              // onChange={handleOptionClick(item.id)}
              className={`px-4 py-2 m-2 cursor-pointer hover:bg-blue-50 border-b ${
                centerSelect === item.id
                  ? 'bg-lightThinBlue text-customBlue font-semibold'
                  : 'text-gray-700 '
              }`}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Centres;
